export const quizSlug = "skincare"
export const quizAnswersStorage = "quiz-answers-v2"
export const quizEmailStorage = "quiz-email-v2"
